module.exports = function(media) {
	'use strict'
	media.directive('mediaEditModal',mediaEditModal);
	mediaEditModal.$inject=['$rootScope','postDataService','alertService', 'serverError','refreshtokenService','putDataService','$timeout','offlineError'];
	function mediaEditModal($rootScope,postDataService,alertService,serverError,refreshtokenService,putDataService,$timeout,offlineError) {
		return {
			restrict: 'E',
			scope: {
				media:'='
			},
			template: require('./partial/mediaModal.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.changeFieldFlag = false;
				$rootScope.modalShow = true;
				var state = "attachments";
				scope.data_grid = scope.media.data_grid;
				scope.mediaIndex = scope.media.selectedMediatoEdit;
				scope.mediaSelected = scope.media.data_grid[scope.mediaIndex];
				scope.media_id = scope.media.attachmentId;
				function changeMediaStatus(postIds, param) {
					if(!postIds) return;
					$rootScope.hasLoaded = false;
					postDataService.save({
						param1:state,
						param2:'status',
						param3:param
					},{
						'ids': postIds,
					}).$promise.then(function(data){
						$rootScope.hasLoaded = true;
						scope.mediaSelected.status = param;
					}, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function(answer) {
									if(answer==200) {
										changeMediaStatus();
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
								 // report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
					});
				}
				scope.changeMediaStatus = function(postId,param) {
					changeMediaStatus([postId], param)
				} 
				scope.resetMediaSelected = function() {
					scope.mediaSelected = undefined;
					scope.$broadcast("change-image", {cancelModal:true});
				}
				scope.beforeImage = function () {
					if(scope.data_grid.length != 1) {
						scope.mediaIndex--;
						if(scope.mediaIndex < 0) {
							scope.mediaIndex = scope.data_grid.length-1;
						} 
						scope.mediaSelected = scope.data_grid[scope.mediaIndex];
						scope.media.selectedImage = scope.mediaIndex;
						scope.media_id = scope.data_grid[scope.mediaIndex]._id;
						scope.$broadcast("change-image", {beforeImage:true});
					}
				}
				scope.afterImage = function() {
					if(scope.data_grid.length != 1) {
						scope.mediaIndex++;
						if(scope.mediaIndex > scope.data_grid.length-1) {
							scope.mediaIndex = 0;
						}
						scope.mediaSelected = scope.data_grid[scope.mediaIndex];
						scope.media.selectedImage = scope.mediaIndex;
						scope.media_id = scope.data_grid[scope.mediaIndex]._id;
						scope.$broadcast("change-image", {afterImage:true});
					}
				}
				var deleteFunction = function() {
			      putDataService.update({
			        param1:'attachments', 
			        param2: 'bulk',
			        param3:'delete'
			        },{
			          'delete_ids':scope.checkedPostsforDelete,
			        }).$promise.then(function(bulkDelete){
			          $rootScope.hasLoaded = true;
			          alertService('success','Success ', bulkDelete.message, 2000);
			          if(scope.media.tableParams) {
			          	scope.media.tableParams.reload();
			          } else {
			          	scope.media.deleteImage(scope.checkedPostsforDelete[0]);
			          }
			          $timeout(function() {
				          scope.media.cancelMediaModal();
				          scope.resetMediaSelected();
			          },0)
			          scope.checkedPostsforDelete = [];
			      }, function(error){
					if(!window.navigator.onLine) {
						offlineError()
						$rootScope.hasLoaded = true;
						alertService('danger','Opps! ', 'Please check your internet connection and try again.');
						return
					}
			        if(error.status ==401) {
			          var promise = refreshtokenService.getAccessToken();
			          promise.then(
			            function(answer) {
			              if(answer==200) {   
			                deleteFunction();
			              }
			            },
			            function(error) {
			              // report something
			            },
			            function(progress) {
			             // report progress
			          });
			        }else if(error.status ==502) {
			          serverError();
			        } else {
			          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
			        }
			        $rootScope.hasLoaded = true;  
			      });
			    }
			    scope.deleteMedia = function() {
			    	$rootScope.hasLoaded = false;
				    scope.checkedPostsforDelete= [];
				    scope.checkedPostsforDelete.push(scope.media_id)
				    deleteFunction();  
			    }
				var postFunction = function() {	
				    postDataService.save({
			          param1:state,
			          param2:'update',
			          id:scope.media_id
			        },{
			        	'title': scope.mediaSelected.title,
			        	'signature': scope.mediaSelected.signature,
			        	'image_alt': scope.mediaSelected.image_alt,
			        	'description': scope.mediaSelected.description,
						'signature_url': scope.mediaSelected.meta.signature_url,
						'gallery_title': scope.mediaSelected.gallery_title
			        }).$promise.then(function(data){
			        	$rootScope.hasLoaded = true;
			          alertService('success','Success ', data.message, 2000);
			        }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
			          	if(error.status ==401) {
			            var promise = refreshtokenService.getAccessToken();
			            promise.then(
			              function(answer) {
			                if(answer==200) {
			                  postFunction();
			                }
			              },
			              function(error) {
			                // report something
			              },
			              function(progress) {
			               // report progress
			            });
			          } else if(error.status ==502) {
			            serverError()
			          } else {
			            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
			          }
			          $rootScope.hasLoaded = true;
			        });
			    }
			    scope.changeField = function() {
			    	scope.changeFieldFlag = true;
			    }
			    scope.outFocus = function() {
						// if(scope.titleExceed) {
						// 	alertService('danger','Opps! ', 'Maximum number of characters in description is 200');
						// 	return
						// }
			    	if(scope.changeFieldFlag ) {
			    		$rootScope.hasLoaded = false;
			    		scope.changeFieldFlag = false;
			    		postFunction();
			    	}
			    }
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/directive/mediaEditModalDirective.js
// module id = 517
// module chunks = 0